import axiosClient from "api/axios_client.js";

// Calls used by more than one module under /swiftboard.
// A call used by only one module belongs in that module's own api.js.
const apiShared = {
  // company-management, email-management (campaign audience)
  getAllCompanies: (payload) => axiosClient.post(`/companies/company-configuration/get-all`, payload),

  // central-directories (trade of work), email-management (campaign audience)
  getAllTradeOfWork: (payload) => axiosClient.post(`/directories/business-master/trade-of-work/get-all`, payload),

  // employee-management, live-projects (employee assignment)
  getAllAssignedEmployees: (payload) => axiosClient.post("/user/get-all-assigned-employee", payload),

  // live-projects, project-history (admin Client filter): clients with at least one of the caller's projects
  getProjectClients: () => axiosClient.get("/project/admin/get-clients"),

  // live-projects, project-history (client Assigned To filter): admins assigned to the caller's projects
  getProjectAdmins: () => axiosClient.get("/project/client/get-admins"),
};

export default apiShared;
